var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.cookieIsSet)?_c('question-navigator'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }